import styled from 'styled-components';
export const StyledTableBody = styled.tbody `
  &:before {
    content: '';
    background: transparent;
    display: var(--table-display-head-body-gap);
    height: var(--table-display-head-body-gap-spacing);
  }
`;
